'use strict';

/**
 * The following Javascript Module provides scripting for the necessary
 * UX elements of the warranty landing page
 */

/**
 * Hide the Form
 */
function hideTheForm() {
    var toggableFormFields = $('.toggable-form-fields');

    toggableFormFields.addClass('d-none');
}

/**
 * Show the Form
 */
function showTheForm() {
    var toggableFormFields = $('.toggable-form-fields');

    toggableFormFields.removeClass('d-none');
}

/**
 * Update the Form
 * If the purchased after checkbox is not checked, hide otherwise show
 */
function updateTheForm() {
    var purchasedAfterCheckbox = $('#warranty-request-purchasedAfter');

    if (purchasedAfterCheckbox.length > 0) {
        if (purchasedAfterCheckbox.is(':checked')) {
            showTheForm();
        } else {
            hideTheForm();
        }
    }
}

module.exports = {
    init: function () {
        updateTheForm();

        $('#warranty-request-purchasedAfter').on('change', updateTheForm);
    }
};
